import React, {useContext} from 'react';
import {useFormContext} from "react-hook-form";
import useFieldArrayClean from "../../../../../hooks/use-field-array-clean.js";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import {BoFormContext} from "../context/bo-form-context.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import {MaskDefault} from "../../../../../utils/mask.js";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {getCities, getNeighborhoods, getStreets} from "../../../../../utils/location-utils.js";
import optionsUtils from "../../../../../utils/options-utils.js";

const BoFormCompany = () => {
    const {control} = useFormContext();
    const {isSync} = useContext(BoFormContext);

    const {fields, append, remove} = useFieldArrayClean({
        control,
        name: "companyList"
    });

    return (
        <Card>
            <Card.Header>
                <Card.Title>Empresas</Card.Title>
            </Card.Header>

            <Card.Body className={"space-y-4"}>
                {
                    fields.map((item, index) => (
                        <SentryRow className={"p-4 border border-[#e5e7eb] rounded-md relative"} key={"company-" + item.itemId}>
                            {
                                (isSync || !!item.__isNew) &&
                                <Button className={"absolute -top-[10px] -right-[10px] !py-0 !px-0 !w-[25px] !h-[25px] z-10"} target={"danger"} onClick={() => remove(index)}>
                                    <FaTrash />
                                </Button>
                            }

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.cnpj`}
                                label={"CNPJ"}
                                mask={MaskDefault.cnpj}
                                classNameWrapper={"col-span-2"}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.name`}
                                label={"Nome"}
                                classNameWrapper={"col-span-5"}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.phone`}
                                label={"Telefone"}
                                mask={MaskDefault.phone}
                                classNameWrapper={"col-span-2"}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.email`}
                                label={"E-mail"}
                                classNameWrapper={"col-span-3"}
                            />

                            <FormField
                                name={`companyList.${index}.address.address`}
                                customRender={field => (
                                    <SelectComponent
                                        instanceId={`companyList.${index}.address.address`}
                                        classNameWrapper={"col-span-6"}
                                        loadOptions={getStreets}
                                        value={optionsUtils.getValue(field.value)}
                                        isAsync={true}
                                        label={"Logradouro"}
                                        onChange={(selected) => field.onChange(selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                )}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.address.number`}
                                label={"Número"}
                                classNameWrapper={"col-span-1"}
                            />

                            <FormField
                                name={`companyList.${index}.address.neighborhood`}
                                customRender={field => (
                                    <SelectComponent
                                        instanceId={`companyList.${index}.address.neighborhood`}
                                        classNameWrapper={"col-span-5"}
                                        loadOptions={getNeighborhoods}
                                        value={optionsUtils.getValue(field.value)}
                                        isAsync={true}
                                        label={"Bairro"}
                                        onChange={(selected) => field.onChange(selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                )}
                            />

                            <FormField
                                name={`companyList.${index}.address.city`}
                                customRender={field => (
                                    <SelectComponent
                                        instanceId={`companyList.${index}.address.city`}
                                        classNameWrapper={"col-span-4"}
                                        loadOptions={getCities}
                                        value={optionsUtils.getValue(field.value)}
                                        isAsync={true}
                                        label={"Município"}
                                        onChange={(selected) => field.onChange(selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                )}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.address.complement`}
                                label={"Complemento"}
                                classNameWrapper={"col-span-6"}
                            />

                            <FormField
                                as={InputForm}
                                name={`companyList.${index}.address.zipCode`}
                                label={"CEP"}
                                mask={MaskDefault.cep}
                                classNameWrapper={"col-span-2"}
                            />
                        </SentryRow>
                    ))
                }

                <Button onClick={() => append({ itemId: fields?.at(-1) ? (fields?.at(-1).itemId + 1) : 1, __isNew: true })}>
                    <FaPlus /> Adicionar empresa
                </Button>
            </Card.Body>
        </Card>
    );
};

export default BoFormCompany;